import React from 'react';

const WhyLLMs = () => {
    return (
        <div
            className="section-py bg-grey dark:bg-black border-b"
            style={{
                borderImageSource: 'linear-gradient(270deg, rgba(60, 69, 97, 0) 0%, #3C4561 50%, rgba(60, 69, 97, 0) 100%)',
                borderImageSlice: 1,
            }}
        >
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-6">
                        <h2 className="text-primary mb-4" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Building The Enterprise of The Future
                        </h2>
                        <p
                            className="text-secondary mb-0 dark:text-[#D7DEE5]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200"
                        >
                            Conversational AI & RAG represent more than just a technology shift; they mark a transformation in how
                            knowledge flows within businesses. With scalable enterprise chatbots, semantic search systems, and
                            knowledge bots powered by LLMs, companies can create a living, continuously learning interface that
                            adapts with every interaction.
                        </p>
                    </div>
                    <div className="lg:col-span-6">
                        <p className="mb-4 dark:text-[#D7DEE5]" data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            By bridging human intelligence with Retrieval-Augmented Generation frameworks and leveraging
                            LangChain, vector databases, and MCP-secured deployments, your enterprise can move beyond automation
                            toward intelligent decision enablement.
                        </p>
                        <p className="mb-0 dark:text-[#D7DEE5]" data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            Our goal is simple: create AI-driven assistants that learn your business language, understand your
                            users, and deliver measurable business outcomes. From fast POCs to production-ready RAG pipelines,
                            every deployment is built for performance, compliance, and trust.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhyLLMs;
